import React from "react";
import { IAhRecord, IDoctor, IPlanDetailsOurData } from "../../interfaces/api";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

const DoctorDrugInfoTripled = ({
  doctor,
  planData,
  plansQuantity,
}: {
  doctor: IDoctor;
  planData: IPlanDetailsOurData;
  plansQuantity: number;
}) => {
  function isPbpInAhRecords(
    pbpToCheck: string,
    ahRecords: IAhRecord[]
  ): boolean {
    for (const ahRecord of ahRecords) {
      if (ahRecord.pbp.some((plan) => plan.pbpid === pbpToCheck)) {
        return true;
      }
    }
    return false;
  }
  function ishcodeInAhRecords(
    hcodeToCheck: string,
    ahRecords: IAhRecord[]
  ): boolean {
    for (const ahRecord of ahRecords) {
      if (ahRecord.pbp.some((plan) => plan.healthPlanID === hcodeToCheck)) {
        return true;
      }
    }
    return false;
  }

  const pbpToCheck = planData.company[0].healthPlan[0].pbp[0].id;
  const hcodeToCheck = planData.company[0].healthPlan[0].hCode;

  const isPbpFound = isPbpInAhRecords(pbpToCheck, doctor.ahRecords);
  const isHcodeFound = ishcodeInAhRecords(hcodeToCheck, doctor.ahRecords);

  const isCovered = isPbpFound && isHcodeFound ? true : false;

  return (
    <div
      className={plansQuantity === 3 ? "small-3" : "small-4"}
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {isCovered ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiOutlineCheck style={{ color: "#215732", fontSize: 40 }} />
          <div style={{ paddingLeft: 8 }}>covered</div>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiOutlineClose style={{ color: "#C23A25", fontSize: 40 }} />
          <div style={{ paddingLeft: 8 }}>not covered</div>
        </div>
      )}
    </div>
  );
};

export default DoctorDrugInfoTripled;
